import { defaultTo } from 'lodash';
import { IBuyPackageResponse } from '../../../repositories/billing-service-packages-balancer/v2/buy-package';
import { ECode } from '../../../repositories/billing-service-packages-balancer/entities/Purchase/AddServicePackageV2Response';
import { IBuyPackageResult } from '../../../thunks/runBuyPackageLegacy/afterPurchasingPackage';

export const mapResponse200 = (response: IBuyPackageResponse): IBuyPackageResult => {
  switch (response.code) {
    case ECode.Ok:
      return { isSuccess: true };

    case ECode.NotEnoughMoney:
      return {
        isSuccess: false,
        amount: defaultTo(response.balanceDetails?.notEnough, 0),
      };

    default:
      return { isSuccess: false };
  }
};
